import React, { Fragment } from "react";

import * as R from "ramda";

import gql from "graphql-tag";
import { graphql } from "react-apollo";

import { compose, withState } from "recompose";

import { Flex, Text } from "src/components";

const DevContainer = ({ children, data }) => <Fragment>{children}</Fragment>;

const usersQuery = gql`
  {
    users {
      id
    }
  }
`;

const enhance = compose(
  graphql(usersQuery, {
    props: ({ ownProps, data }) => {
      if (!data.users) {
        return { ...ownProps, data };
      }

      const token = localStorage.getItem("token");

      const ids = R.map(R.prop("id"), data.users);

      const newToken = R.contains(token, ids) ? token : R.head(ids);

      if (newToken !== token) {
        localStorage.setItem("token", newToken);
      }

      return {
        ...ownProps,
        data,
      };
    },
  })
);

// export default enhance(DevContainer);
export default DevContainer;



// WEBPACK FOOTER //
// ./src/graphql/DevContainer.js